"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledShade = exports.StyledCarouselSlide = exports.Root = exports.CarouselComponent = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  order: 1,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    order: 3
  }
}));
const CarouselComponent = exports.CarouselComponent = (0, _mui.styled)(_presentationComponents.Carousel)(({
  theme
}) => ({
  display: 'grid',
  margin: theme.spacing(0, -3),
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(0, -6)
  }
}));
const StyledShade = exports.StyledShade = (0, _mui.styled)(_presentationComponents.Shade, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isCurrent'])
})(({
  isCurrent
}) => ({
  marginTop: isCurrent ? 0 : '3px'
}));
const StyledCarouselSlide = exports.StyledCarouselSlide = (0, _mui.styled)(_presentationComponents.CarouselSlide, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isLast', 'index'])
})(({
  index,
  isLast,
  theme
}) => ({
  height: _presentationComponents.SHADES_SIZE_CURRENT + 3,
  transform: `translate3d(${_constants.SPACING * index}px, 0px, 0px)`,
  justifyContent: 'center',
  display: 'flex',
  marginLeft: isLast ? -3 : 0
}));
//# sourceMappingURL=styles.js.map